import gql from "graphql-tag"

import { MONEY_FRAGMENT } from "@app/graphql/fragments/moneyFragment"
import { VARIANT_WITH_PRODUCT_FRAGMENT } from "@app/graphql/fragments/variantWithProductFragment"

export const CART_FRAGMENT = gql`
  fragment CartFragment on Cart {
    attributes {
      key
      value
    }
    buyerIdentity {
      countryCode
      customer {
        id
        email
        firstName
        lastName
        displayName
      }
      email
      phone
    }
    checkoutUrl
    cost {
      subtotalAmount {
        ...MoneyFragment
      }
      totalAmount {
        ...MoneyFragment
      }
      totalTaxAmount {
        ...MoneyFragment
      }
    }
    createdAt
    discountAllocations {
      ... on CartCustomDiscountAllocation {
        __typename
        title
        discountedAmount {
          ...MoneyFragment
        }
      }
      ... on CartAutomaticDiscountAllocation {
        __typename
        title
        discountedAmount {
          ...MoneyFragment
        }
      }
      ... on CartCodeDiscountAllocation {
        __typename
        code
        discountedAmount {
          ...MoneyFragment
        }
      }
    }
    discountCodes {
      applicable
      code
    }
    id
    lines(first: 250) {
      edges {
        node {
          attributes {
            key
            value
          }
          cost {
            amountPerQuantity {
              ...MoneyFragment
            }
            compareAtAmountPerQuantity {
              ...MoneyFragment
            }
            subtotalAmount {
              ...MoneyFragment
            }
            totalAmount {
              ...MoneyFragment
            }
          }
          discountAllocations {
            ... on CartCustomDiscountAllocation {
              __typename
              title
              discountedAmount {
                ...MoneyFragment
              }
            }
            ... on CartAutomaticDiscountAllocation {
              __typename
              title
              discountedAmount {
                ...MoneyFragment
              }
            }
            ... on CartCodeDiscountAllocation {
              __typename
              code
              discountedAmount {
                ...MoneyFragment
              }
            }
          }
          id
          merchandise {
            ...AppVariantWithProductFragment
          }
          quantity
          ... on ComponentizableCartLine {
            lineComponents {
              id
              merchandise {
                ...AppVariantWithProductFragment
              }
              quantity
              cost {
                totalAmount {
                  ...MoneyFragment
                }
                subtotalAmount {
                  ...MoneyFragment
                }
              }
            }
          }
        }
      }
    }
    note
    totalQuantity
    updatedAt
  }
  ${MONEY_FRAGMENT}
  ${VARIANT_WITH_PRODUCT_FRAGMENT}
`
